import { useTranslate } from '@tolgee/react';
import React from 'react';
import { FileDrop } from 'react-file-drop';
import styled from 'styled-components';

const PresentationFileDropV2 = ({
  onFilesDropped,
}: {
  onFilesDropped?: (
    files: FileList | null,
    event: React.DragEvent<HTMLDivElement>,
  ) => void;
}) => {
  const { t } = useTranslate();
  return (
    <Container>
      {/* @ts-ignore */}
      <FileDrop onDrop={(files, event) => onFilesDropped && onFilesDropped(files, event)}>
        <ContentContainer>
          <Title>{t('Drag and drop or click to select a presentation')}</Title>
          <Description>
            {t(
              'PresentationSupportedFileTypes',
              'Supported file types are .pptx, .ppt, .key, .pdf',
            )}
          </Description>
        </ContentContainer>
      </FileDrop>
    </Container>
  );
};

export default PresentationFileDropV2;

const Title = styled.p`
  &&& {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0px;
    margin-top: 0px;
    text-align: center;
    user-select: none;
    color: white;
  }

  @media (max-width: 500px) {
    &&& {
      font-size: 14px;
    }
  }
`;

const Description = styled.p`
  &&& {
    font-size: 14px;
    font-weight: normal;
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: center;
    user-select: none;
    color: white;
  }
  @media (max-width: 500px) {
    &&& {
      font-size: 12px;
    }
  }
`;

const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  border: 1px dashed white;
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(58, 175, 255, 1);
  cursor: pointer;

  &:hover {
    background-color: rgba(58, 175, 255, 0.1);
  }

  &:active {
    background-color: rgba(58, 175, 255, 0.2);
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;

  .file-drop {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .file-drop-target {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .file-drop > .file-drop-target.file-drop-dragging-over-frame > div {
    background-color: rgba(58, 175, 255, 0.2);
  }
`;
